export default __webpack_public_path__ + "static/media/user.692452b4.svg";